export default (state, action) => {
    switch (action.type) {
        case 'TOGGLE_PROFILE_COMPLETION':
            return action.data;
        default:
            return state || { show: false, origin: '' };
    }
};
